import { render, staticRenderFns } from "./topic-details.vue?vue&type=template&id=8f565410&"
import script from "./topic-details.vue?vue&type=script&lang=js&"
export * from "./topic-details.vue?vue&type=script&lang=js&"
import style0 from "./topic-details.vue?vue&type=style&index=0&id=8f565410&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports